module.exports = __webpack_public_path__ + "img/618cef496bc62f2511e8134f08b42349.9d1ad962.png";